import { PROFANE_WORDS } from "../../constants/microphone/profaneWords";

const badWordsRE = new RegExp(`\\b(${PROFANE_WORDS.join('|')})\\b`, "gi");

export function filterProfanity(text: string): string {
    return text.replace(badWordsRE, "****");
}
